module.exports = __webpack_public_path__ + "static/img/game-logo-horse.3fe6d66.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/build922/assets/image/gamelogo/game-logo-horse.png
// module id = kxKp
// module chunks = 0 1 2 3 4 5 6